<template>
    <div>
        <title>券卡修改</title>
        <article class="cardArticle">
            <section class="cardCon">
                <header class="tabHeader">
                    <p>
                    <router-link :to="{path:'/OperateRecord'}" class="isActive">出库记录</router-link>
                    <router-link :to="{path:'/ActivationRecord'}" >激活记录</router-link>
                    <router-link :to="{path:'/PauseRecord'}" >暂停记录</router-link>
                    <router-link :to="{path:'/ReuseRecord'}" >恢复记录</router-link>
                    </p>
                </header>
                <CardModify :type="3" :batchcode="batchcode"></CardModify>
            </section>
        </article>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "CardsOut",
  // ==================================== 组件====================================
  components: {
    CardModify: resolve =>require(["@/components/CardsFolder/CardModify.vue"],resolve), // 出库组件
  },
  data() {
    return {
			cardqupd:0,
      batchcode:'',
    };
  },
   // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
  // ============================================== 方法 ==============================================
  methods: {
  
  },
  mounted() {
		this.cardqupd =this.ElementControls('cardqupd')
    if(this.$route.query.batchcode){
      this.batchcode =  this.$route.query.batchcode;
    }
  },
  
};
</script>
<style scoped>
/* S 验证券卡 */
.cardCon {
  position: relative;
  padding: 84px 20px 85px 0;
  height: calc(100% - 169px);
}
@media (max-width: 1310px) {
  .cardCon header a {
    padding: 0 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardManage/CardsEdit.vue